/**
 * Every external link and hard fact about the site in one place.
 *
 * These were previously scattered through the Footer's JSX. Centralising them
 * means a changed store URL is a one-line edit.
 */

export const SITE = {
  name: "The Ghost",
  studio: "Gameplier",
  tagline: "Multiplayer Horror",
  email: "gameplier.team@gmail.com",
} as const;

export const STORE = {
  googlePlay:
    "https://play.google.com/store/apps/details?id=com.Gameplier.TheGhost",
  appStore:
    "https://apps.apple.com/us/app/the-ghost-multiplayer-horror/id1557035248",
  /**
   * NOT The Ghost. This is "Cursed Apartment" by Horror Ponds — a separate,
   * free Windows/macOS/Android title on itch.io, linked from the old site.
   * Labelled as itself in the Download section rather than sitting alongside
   * the two store badges, which would imply it's the same game.
   */
  itch: "https://horror-ponds.itch.io/cursedapartment",
} as const;

export const SOCIAL = {
  discord: "https://discord.gg/HwVzkMWrxH",
  facebook: "https://www.facebook.com/Gameplier",
} as const;

/** Store badge artwork already present in /public/img/svg. */
export const BADGES = {
  googlePlay: "GetItOnGooglePlay.webp",
  appStore: "Download_on_the_App_Store_Badge_US.svg",
} as const;
